<template>
  <EditUbicazionePadre
    :id="id"
    :idMagazzino="idMagazzino"
  />
</template>

<script>
import EditUbicazionePadre from '@/components/MAGAZZINO/EditUbicazionePadre.vue';

export default {
  name: 'EditUbicazionePadreView',
  props: ['id', 'idMagazzino', 'duplicateId'],
  components: {
    EditUbicazionePadre,
  },
}
</script>